import React, { FC } from 'react';
import { SVGIcons } from '~/assets';
import {
  ButtonIconText,
  ButtonIconWrapper,
  ButtonTextWrapper,
  IconWrapper,
} from './styles';

type Props = {
  btnText?: string;
  textColor?: string;
  icon?: SVGIconKeys;
  iconProps?: SVGIconProps;
  iconColor?: string;
  onClick?: () => void;
};

const ButtonIcon: FC<Props> = ({
  btnText = 'Tradicionais',
  onClick = () => ({}),
  icon = 'candy',
  iconProps,
}) => (
  <ButtonIconWrapper onClick={onClick}>
    <ButtonTextWrapper>
      <ButtonIconText>{btnText}</ButtonIconText>
    </ButtonTextWrapper>
    <IconWrapper>{SVGIcons[icon](iconProps)}</IconWrapper>
  </ButtonIconWrapper>
);

export default ButtonIcon;
